import classNames from 'classnames';
import type React from 'react';
import type { ComponentProps } from 'react';

import { Button, Heading, Separator } from '../../atoms';
import { CallToAction } from '../CallToAction';

import './thank-you.scss';

interface Props {
  heading: string;
  subheading: React.ReactNode;
  subheading2?: string;
  buttonLabel: string;
  buttonOnClick: () => void;
  buttonVariant?: ComponentProps<typeof Button>['variant'];
  buttonSize?: ComponentProps<typeof Button>['size'];
  resendVerificationButton?: {
    label: string;
    onClick: () => void;
  };
  card?: {
    title: string;
    description: string;
    buttonLabel: string;
    onButtonClick: () => void;
  };
  variant?: 'default' | 'merged';
  className?: string;
}

export const ThankYou = ({
  heading,
  subheading,
  subheading2,
  buttonLabel,
  buttonVariant = 'primary',
  buttonSize = 'large',
  buttonOnClick,
  resendVerificationButton,
  card,
  variant = 'default',
  className,
}: Props) => {
  const isMerged = variant === 'merged';

  return (
    <div
      className={classNames('payflow-ui thank-you', className, {
        'thank-you--merged': variant === 'merged',
      })}
    >
      <div className="thank-you__top-container">
        <Heading level="h3">{heading}</Heading>
        <p className="thank-you__subheading">{subheading}</p>

        {resendVerificationButton && (
          <Button onClick={resendVerificationButton.onClick} size="large" variant="secondary">
            {resendVerificationButton.label}
          </Button>
        )}

        {!isMerged && !resendVerificationButton && (
          <div className="thank-you__separator-container">
            <Separator />
          </div>
        )}

        {subheading2 && <p className="thank-you__subheading-2">{subheading2}</p>}

        <Button onClick={buttonOnClick} size={buttonSize} variant={buttonVariant}>
          {buttonLabel}
        </Button>
      </div>

      {isMerged && (
        <div className="thank-you__separator-container">
          <Separator />
        </div>
      )}

      {card && <CallToAction buttonVariant="secondary" {...card} borderless={isMerged} />}
    </div>
  );
};
